/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyTrxInfo } from './EvmDailyTrxInfo';

export type EvmHomeTotalTokenInfo = {
    TKNTP: EvmHomeTotalTokenInfo.TKNTP;
    TTKNCNT: string;
    TRXHTP: EvmHomeTotalTokenInfo.TRXHTP;
    DTRXLIST: Array<EvmDailyTrxInfo>;
};

export namespace EvmHomeTotalTokenInfo {

    export enum TKNTP {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

